<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <v-card v-if="payload.encontroId">
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"
              >Edição de {{ isAT ? "Agenda" : "Encontro" }}</slot
            >
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <app-group-solution-combobox
              :filter="payload"
              :disabled="true"
              :name="
                isAT
                  ? 'Grupo/Iniciativa'
                  : isSala
                  ? 'Grupo'
                  : 'Grupo de Trabalho'
              "
            >
            </app-group-solution-combobox>
          </v-col>
          <v-col sm="6">
            <div>Criado por:</div>
            <div>
              {{ payload.usuario.nome }}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field v-model="payload.nome" disabled></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00h:00m"
              @blur="setInicioString()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.duracaoString"
              v-mask="'##:##'"
              label="Duração do Evento"
              placeholder="00h:00m"
              @blur="setFimString()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00h:00m"
              @blur="setInicioString()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.solucoesEvento.length > 0">
          <v-col md="9" sm="9" lg="9">
            <v-text-field
              v-model="payload.solucoesEvento[0].nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.solucoesEvento.length > 0">
          <v-col md="9" sm="9" lg="9">
            <v-text-field
              v-if="estado === 'MS'"
              :label="`${isAT ? 'ATS' : 'Consultor'}:`"
              v-model="payload.usuario.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="
            payload.solucoesEvento.length > 0 &&
            payload.solucoesEvento[0].monitoramento === 2
          "
        >
          <v-col md="3" sm="3" lg="3">
            <v-radio-group
              v-model="payload.solucoesEvento[0].tipoMonitoramentoEvento"
            >
              <v-radio
                label="Trabalho de Escritório"
                :key="1"
                :value="1"
              ></v-radio>
              <v-radio label="Visita" :key="2" :value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <template v-if="payload.solucoesEvento.length > 0">
          <v-row>
            <v-col md="9" sm="9" lg="9">
              <v-combobox
                v-model="payload.tarefasEvento"
                :items="tarefas"
                chips
                clearable
                :label="`${isAT ? 'Atividades' : 'Tarefas'}`"
                :item-disabled="disableTasks"
                item-text="nome"
                item-value="municipioTarefaId"
                multiple
              >
                <template v-slot:item="{ item, attrs }">
                  <template v-if="!attrs.disabled">
                    <v-icon>{{ icon(attrs.inputValue) }}</v-icon>
                  </template>
                  <div class="mr-1 ml-1">{{ item.nome }}</div>

                  <template v-if="attrs.disabled">
                    <v-icon color="rgba(0, 0, 0, 0.38)">mdi-check</v-icon>
                  </template>
                </template>
                <template v-slot:selection="{ attrs, item }">
                  <v-chip close @click:close="removeTarefa(item)">
                    <strong>{{ item.nome }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </template>

        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-combobox
              v-model="payload.convidadosEvento"
              :items="membros"
              chips
              clearable
              label="Membros"
              item-value="membroId"
              multiple
            >
              <template v-slot:item="{ attrs, item }">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ item.nome | esconderValores("nome") }}
              </template>
              <template v-slot:selection="{ attrs, item }">
                <v-chip close @click:close="removeMembro(item)">
                  <strong
                    >{{ item.nome | esconderValores("nome") }} -
                    {{ item.cpf | esconderValores("cpf") }}</strong
                  >
                </v-chip>
              </template>
              <template slot="no-data"> Nenhum membro retornado </template>
            </v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="isAT">
          <v-col>
            <v-checkbox
              v-model="payload.sensibilizacao"
              id="sensibilizacao"
              color="primary"
              label="Sensibilização"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.emAndamento"
              id="emAndamento"
              color="primary"
              label="Em Andamento"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.finazacao"
              id="finazacao"
              color="primary"
              label="Finalização"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin ||
            (config.verParcialAcaoFinalizada &&
              groupsConfig.verParcialAcaoFinalizada)
          "
        >
          <v-col class="tipos">
            <div>
              <v-radio-group v-model="payload.encontroType" row>
                <v-radio label="Parcial" value="Parcial"></v-radio>
                <v-radio
                  label="Ação Finalizada"
                  value="Ação Finalizada"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="save()"
          v-show="
            ((isAdmin ||
              isSPFesp ||
              isSPFespEspecial ||
              isSPCoordenador ||
              payload.usuarioId === userTeste.usuarioId) &&
              !payload.temRelatorio) ||
            (isAnalista && this.$store.state.uf === 'MA')
          "
          >Salvar</v-btn
        >
        <v-btn color="info" outlined text @click="createdGuestList()"
          >Lista de Presença</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">{{ isAT ? "Agenda" : "Encontro" }}</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field v-model="payload.nome" disabled></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Início "
              disabled
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Término"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-combobox
              v-model="payload.municipios"
              :items="municipios"
              chips
              label="Municípios"
              item-text="nome"
              item-value="municipioId"
              multiple
              disabled
            >
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
              disabled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="info"
          outlined
          text
          @click="save()"
          v-show="
            (isAdmin || payload.usuarioId === user.usuarioId) &&
            !payload.temRelatorio &&
            payload.encontroId
          "
          >Salvar
        </v-btn>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  cityAPI,
  AppGroupSolutionCombobox,
  citySolutionAPI,
} from "@/modules/city";
import { meetingAPI } from "@/modules/calendar";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import { mapActions, mapGetters } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { esconderPalavras } from "../../helpers/utils";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "AppModalEditMeeting",
  props: {
    dialogEdicao: { type: Boolean, default: false },
    payload: { type: Object },
    meetings: { type: Array },
  },
  components: {
    AppGroupSolutionCombobox,
  },
  data() {
    return {
      menu: "",
      menu2: "",
      panel: 0,
      date: null,
      time: null,
      tarefas: [],
      membros: [],
      showDialog: this.dialogEdicao,
      municipio: {},
      estado: this.$store.state.uf,
      municipios: [],
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    icon(item) {
      if (item) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    disableTasks(item) {
      return item.realizada;
    },
    alertTarefa() {
      Swal.fire({
        title: "Atenção!",
        text: `${this.isAT ? "Esta agenda" : "Este encontro"} não possui ${
          this.isAT ? "atividades" : "tarefas"
        } selecionadas. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveEncontro();
        }
      });
    },
    getTasks() {
      this.setLoading(true);
      cityTaskAPI
        .getTasks(
          this.payload.solucoesEvento.map(function (item) {
            return item.municipioSolucaoId;
          })
        )
        .then((resp) => {
          this.tarefas = resp.data.filter((response) => {
            return !response.desabilitado;
            // this.tarefas = resp.data
          });

          if (
            !this.isFullAdmin &&
            !this.config.visualizaTarefasExecutadas &&
            !this.groupsConfig.visualizaTarefasExecutadas
          ) {
            this.tarefas = this.tarefas.filter((item) => !item.realizada);
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    removeSolucao(item) {
      if (this.payload.solucoesEvento.length > 0) {
        this.payload.solucoesEvento.splice(
          this.payload.solucoesEvento.indexOf(
            this.payload.grupo.municipioSolucao
          ),
          1
        );
      }
      this.payload.solucoesEvento = [...this.payload.solucoesEvento];
      this.tarefas = [];
      this.chipsTarefas = [];
      if (this.payload.grupo.municipioSolucao) {
        this.payload.solucoesEvento.push(this.payload.grupo.municipioSolucao);
      }
      this.removeTarefa();
    },
    removeTarefa(item) {
      if (this.payload.tarefasEvento.length > 0) {
        this.payload.tarefasEvento.splice(
          this.payload.tarefasEvento.indexOf(item),
          1
        );
      } else {
        this.payload.tarefasEvento = [];
      }
      this.payload.tarefasEvento = [...this.payload.tarefasEvento];
    },
    removeMembro(item) {
      this.payload.convidadosEvento.splice(
        this.payload.convidadosEvento.indexOf(item),
        1
      );
      this.payload.convidadosEvento = [...this.payload.convidadosEvento];
    },
    async save() {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de início do evento"
        );
      } else if (
        !this.payload.fimString ||
        this.payload.fimString.length < 16
      ) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de término do evento"
        );
      } else if (this.repeatedMeetings()) {
        this.$notification.error(
          "Já existe outro evento do mesmo grupo na mesma data"
        );
      } else {
        if (this.payload.tarefasEvento.length == 0) {
          this.alertTarefa();
        } else {
          this.saveEncontro();
        }
      }
    },
    async saveEncontro() {
      this.setLoading(true);
      const tarefasId = this.payload.tarefasEvento
        .map((item) => item.municipioTarefaId)
        .join(",");
      const { municipioSolucaoId, maxHoras } = this.payload.solucoesEvento[0];

      let errorHours;
      if (tarefasId && municipioSolucaoId && maxHoras)
        await citySolutionAPI
          .verifyHoursSolution(tarefasId, municipioSolucaoId)
          .then((data) => {
            if (data.data.errorMaxHour) {
              errorHours = "error";

              this.setLoading(false);

              this.$notification.error(
                "A(s) tarefa(s) ultrapassa(m) o limite de horas da solução"
              );
            }
          });
      if (!errorHours) {
        meetingAPI
          .update(this.payload)
          .then((resp) => {
            this.$emit("onSave");
            this.showDialog = false;
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              `Erro ao atualizar ${this.isAT ? "a agenda" : "o encontro"}`
            );
          });
      }
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.municipio = resp.data;
          this.loadCities();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    close() {
      this.$emit("closeDialog");
    },
    setInicioString() {
      var a = moment(this.payload.fimString, "DD/MM/YYYY HH:mm");
      var b = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm");
      var diff_s = a.diff(b, "seconds");
      this.payload.duracaoString = moment
        .utc(moment.duration(diff_s, "seconds").asMilliseconds())
        .format("HH:mm");

      this.$forceUpdate();
      return this.payload.fimString;
    },
    setFimString() {
      let inicioDate = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
        .add(this.payload.duracaoString.substring(0, 2), "hours")
        .format("DD/MM/YYYY HH:mm");
      this.payload.fimString = moment(inicioDate, "DD/MM/YYYY HH:mm")
        .add(this.payload.duracaoString.substring(3), "minutes")
        .format("DD/MM/YYYY HH:mm");
      this.$forceUpdate();
      return this.payload.fimString;
    },

    loadCities() {
      this.setLoading(true);
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
          this.getMembers();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter municípios");
        });
    },
    repeatedMeetings() {
      let repeated = false;

      this.meetings.forEach((meeting) => {
        if (
          this.payload.grupoId === meeting.grupoId &&
          this.payload.inicioString === meeting.inicioString &&
          this.payload.encontroId !== meeting.encontroId
        ) {
          repeated = true;

          this.payload.convidadosEvento.forEach((convidadoEvento) => {
            if (
              meeting.convidadosEvento.some(
                (convidado) => convidado.membroId === convidadoEvento.membroId
              )
            ) {
              this.repeatedInvite = true;
            }
          });
        }
      });

      return repeated;
    },
    createdGuestList() {
      let rows = [];
      let columnHeader = [
        "Participante",
        "CPF",
        "Telefone",
        "E-mail",
        "Assinatura",
      ];
      if (this.estado === "MS") {
        columnHeader = ["Participante", "Telefone", "E-mail", "Assinatura"];
      }

      let pdfName =
        "Lista de Presença - " +
        this.payload.grupo.nome +
        " - " +
        this.payload.inicioString;

      var doc = new JsPDF("l", "pt");

      var header = function (data) {
        var logoUf;
        var logoSebrae = new Image();
        logoSebrae.src = "/assets/img/sebrae-logo.png";
        doc.addImage(logoSebrae, "png", 650, 20, 140, 62);

        logoUf = new Image();
        logoUf.src = "/assets/img/logo_nacional.png_color.png";
        doc.addImage(logoUf, "png", 40, 20, 157, 62);
      };

      if (this.estado === "SC") {
        header = function (data) {
          var logoUf;
          var logoSebrae = new Image();
          logoSebrae.src = "/assets/img/sebrae-logo.png";
          doc.addImage(logoSebrae, "png", 650, 20, 140, 62);

          logoUf = new Image();
          logoUf.src = "/assets/img/logo_nacional.png_color.png";
          doc.addImage(logoUf, "png", 40, 20, 157, 62);
        };
      }

      if (this.estado === "BA") {
        header = function (data) {
          var logoUf;
          // var logoMeio
          var logoSebrae = new Image();
          logoSebrae.src = "/assets/img/sebrae-logo.png";
          doc.addImage(logoSebrae, "png", 650, 20, 140, 62);

          logoUf = new Image();
          logoUf.src = `/assets/img/logo_nacional.png_color.png`;
          doc.addImage(logoUf, "png", 40, 20, 157, 62);
        };
      }

      if (this.estado === "SP") {
        header = function (data) {
          var logoUf;
          var logoMeio;
          var logoSebrae = new Image();
          logoSebrae.src = "/assets/img/sebrae-logo.png";
          doc.addImage(logoSebrae, "png", 650, 20, 140, 62);
          logoMeio = new Image();
          logoMeio.src = "/assets/img/fesp_correto.png";
          doc.addImage(logoMeio, "png", 350, 20, 157, 55);

          logoUf = new Image();
          logoUf.src = "/assets/img/logo_consorcio.png";
          doc.addImage(logoUf, "png", 40, 20, 157, 62);
        };
      }

      if (this.estado === "MA" && this.municipio.projetoId !== 6) {
        header = function (data) {
          var logoUf;
          var logoSebrae = new Image();
          logoSebrae.src = "/assets/img/sebrae-logo.png";
          doc.addImage(logoSebrae, "png", 650, 20, 140, 62);

          logoUf = new Image();
          logoUf.src = "/assets/img/logo_nacional.png_color.png";
          doc.addImage(logoUf, "png", 40, 20, 157, 62);
        };
      }

      if (this.estado === "MA" && this.municipio.projetoId === 2) {
        header = function (data) {
          var logoUf;
          var logoSebrae = new Image();
          logoSebrae.src = "/assets/img/sebrae-logo.png";
          doc.addImage(logoSebrae, "png", 650, 20, 140, 62);

          var logoMeio;
          logoMeio = new Image();
          logoMeio.src = "/assets/img/logo_gov_ma.jpeg";
          doc.addImage(logoMeio, "jpg", 350, 20, 200, 70);

          logoUf = new Image();
          logoUf.src = "/assets/img/logo_nacional.png_color.png";
          doc.addImage(logoUf, "png", 40, 20, 157, 62);
        };
      }

      doc.text("Lista de Presença", 40, 120);
      doc.setFontSize(14).setFont(undefined, "normal");
      var cidade = doc.splitTextToSize(this.city, 1000);
      var strArr = doc.splitTextToSize(this.payload.grupo.nome, 1000);
      doc.text(cidade, 40, 140);
      doc.text(strArr, 40, 160);
      // doc.text('Evento: ' + this.payload.grupo.nome, 40, 140)
      doc.setFontSize(12).setFont(undefined, "normal");
      doc.text("Data: " + this.payload.inicioString, 40, 180);

      for (let i = 0; i < this.payload.convidadosEvento.length; i++) {
        if (this.estado === "MS") {
          rows.push([
            esconderPalavras(this.payload.convidadosEvento[i].nome, "nome"),
            esconderPalavras(
              this.payload.convidadosEvento[i].telefone,
              "telefone"
            ),
            esconderPalavras(this.payload.convidadosEvento[i].email, "email"),
            "",
          ]);
        } else {
          rows.push([
            esconderPalavras(this.payload.convidadosEvento[i].nome, "nome"),
            esconderPalavras(this.payload.convidadosEvento[i].cpf, "cpf"),
            esconderPalavras(
              this.payload.convidadosEvento[i].telefone,
              "telefone"
            ),
            esconderPalavras(this.payload.convidadosEvento[i].email, "email"),
            "",
          ]);
        }
      }

      for (let i = 0; i < 5; i++) {
        rows.push(["", "", "", "", ""]);
      }

      doc.autoTable(columnHeader, rows, {
        beforePageContent: header,
        startY: 200,
        margin: {
          top: 160,
        },
        styles: { overflow: "linebreak", cellWidth: "wrap" },
        showHead: "firstPage",
      });

      doc.save(pdfName + ".pdf");
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "user",
      "isSPFesp",
      "isAnalista",
      "isSPFespEspecial",
      "isSPCoordenador",
      "city",
      "isAT",
      "isSala",
      "isFullAdmin",
    ]),
  },
  watch: {
    dialogEdicao(value) {
      this.showDialog = value;
      if (value) {
        if (this.payload.encontroId) {
          this.getTasks();
        }
      }
    },
  },
  created() {
    this.loadCity();
  },
};
</script>
